import { render, staticRenderFns } from "./EntityTabs.vue?vue&type=template&id=60f97c58&"
import script from "./EntityTabs.vue?vue&type=script&lang=ts&"
export * from "./EntityTabs.vue?vue&type=script&lang=ts&"
import style0 from "./EntityTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports